let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("geBQz")).then(() => parcelRequire('k2Gr1'));